import React from "react";

export default function FieldsList({ r }) {
  const items = [
    ["first / last", `${r.first_name || ""} / ${r.last_name || ""}`],
    ["nickname", r.nickname],
    ["business", r.business_name],
    ["brokerage", r.brokerage_name],
    ["phone", r.phone],
    ["email", r.email],
    ["source", r.source],
    ["website", r.realtor_website_url],
    ["photo", r.photo_url ? "✓" : ""],
    ["FB", r.facebook_url ? "✓" : ""],
    ["IG", r.instagram_url ? "✓" : ""],
    ["LI", r.linkedin_url ? "✓" : ""],
  ];
  return (
    <dl className="mt-1.5 text-xs text-slate-600 grid grid-cols-2 gap-x-2 gap-y-0.5">
      {items.map(([k, v]) => v ? (
        <React.Fragment key={k}>
          <dt className="text-slate-400">{k}</dt>
          <dd className="truncate">{v}</dd>
        </React.Fragment>
      ) : null)}
    </dl>
  );
}
